module.exports = __webpack_public_path__ + "static/media/heroImage.bbaa40ef.png";